// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideInRight {
    from {
        transform: translate(100%, -50%);
    }
    to {
        transform: translate(0, -50%);
    }
}

@keyframes slideOutRight {
    from {
        transform: translate(0, -50%);
    }
    to {
        transform: translate(100%, -50%);
    }
}

.right-modal-content {
    position: absolute;
    border: 1px solid #ccc;
    background: #fff;
    overflow: auto;
    border-radius: 4px;
    outline: none;
}

.right-modal-content--after-open {
    animation: slideInRight 0.5s ease-out forwards;
}

.right-modal-content--before-close {
    animation: slideOutRight 0.5s ease-in forwards;
}
`, "",{"version":3,"sources":["webpack://./src/app/Modal.css"],"names":[],"mappings":"AAAA;IACI;QACI,gCAAgC;IACpC;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD","sourcesContent":["@keyframes slideInRight {\n    from {\n        transform: translate(100%, -50%);\n    }\n    to {\n        transform: translate(0, -50%);\n    }\n}\n\n@keyframes slideOutRight {\n    from {\n        transform: translate(0, -50%);\n    }\n    to {\n        transform: translate(100%, -50%);\n    }\n}\n\n.right-modal-content {\n    position: absolute;\n    border: 1px solid #ccc;\n    background: #fff;\n    overflow: auto;\n    border-radius: 4px;\n    outline: none;\n}\n\n.right-modal-content--after-open {\n    animation: slideInRight 0.5s ease-out forwards;\n}\n\n.right-modal-content--before-close {\n    animation: slideOutRight 0.5s ease-in forwards;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
